import { Link } from "react-router-dom";
import { PageHeader, Reveal } from "@/components/site/Reveal";
import { useContent } from "@/context/ContentContext";
import { IMG } from "@/lib/images";
import { PackageOffer, OnlineCourseSoon } from "@/components/site/PackageOffer";

export default function Courses() {
  const c = useContent();
  return (
    <div data-testid="courses-page">
      <PageHeader eyebrow="Sykurs og personlig veiledning" title="Lær å sy i ditt eget tempo" intro="Små grupper eller en-til-en med Liisa. Du lærer teknikkene, og går hjem med et plagg du har sydd selv." testid="courses-header" />
      {c?.settings?.courses_info && (
        <section className="px-6 md:px-16 lg:px-24 mb-14">
          <Reveal className="bg-[#F0EBE1] p-8 md:p-10 max-w-4xl">
            <p className="eyebrow mb-3">Praktisk informasjon</p>
            <p className="text-[#1A1A1A] leading-relaxed" data-testid="courses-info">{c.settings.courses_info}</p>
          </Reveal>
        </section>
      )}
      <section className="px-6 md:px-16 lg:px-24 grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-4 lg:sticky lg:top-28 self-start">
          <img src={IMG.sewing} alt="Sykurs i atelieret" className="w-full h-[420px] object-cover" />
        </Reveal>
        <div className="lg:col-span-8 grid sm:grid-cols-2 gap-6">
          {(c?.courses || []).map((k, i) => (
            <Reveal key={k.id} delay={(i % 2) * 0.1} className="border border-[#E5E0D8] p-8 flex flex-col hover:border-[#C4A47C] transition-colors duration-300">
              <div data-testid={`course-card-${i}`} className="flex flex-col h-full">
                <p className="text-xs tracking-[0.18em] uppercase text-[#8C6E48]">{k.level}</p>
                <h2 className="text-3xl font-medium mt-3">{k.title}</h2>
                <p className="mt-4 text-sm text-[#5C5A56] leading-relaxed flex-1">{k.description}</p>
                <div className="mt-6 pt-5 border-t border-[#E5E0D8] text-sm flex justify-between gap-4">
                  <span>{k.duration}</span>
                  <span className={k.price ? "font-medium" : "italic text-[#8C6E48]"}>{k.price || "Be om pristilbud"}</span>
                </div>
                <Link to="/bestill?type=kurs#forespørsel" className="mt-6 text-sm border-b border-[#1A1A1A] self-start pb-1 hover:text-[#8C6E48] hover:border-[#8C6E48] transition-colors" data-testid={`course-signup-${i}`}>Meld interesse</Link>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <PackageOffer />
      <OnlineCourseSoon />
    </div>
  );
}
